import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  isLoading: true,
  shouldLoad: true,
  sections: []
}

export const home = createSlice({
  name,
  initialState,
  reducers: {
    setHomePageSections: (state, { payload }) => {
      state.sections = payload
      state.isLoading = false
      state.shouldLoad = false
    },
    resetLoading: (state) => {
      state.isLoading = true
      state.shouldLoad = true
    }
  }
})

export const { setHomePageSections, resetLoading } = home.actions

export default home.reducer
